import { useContext } from "react";
import { NotificationContext } from "../../components/Misc/Notification/commons/NotificationProvider";

const useNotification = () => {
  const notification = useContext(NotificationContext);

  return {
    ...notification,
  };
};

export default useNotification;
